import Vue from "vue";
import AnnouncementListingService from "./AnnouncementListingService.vue";

export function load() {
  const selector = "announcement-listingService-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(AnnouncementListingService, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
